import { useMemo } from 'react'
import { useGetWaitingRoomDoctorsQuery } from '@/core/services/waiting-room'
import { useRoomDoctorStatuses } from '@/hooks/useRoomDoctorStatuses'

export function useDoctorsLoader(waitingRoomId: string) {
  const { data: doctors } = useGetWaitingRoomDoctorsQuery(waitingRoomId)
  // Merged HTTP snapshot + socket events: the socket-only Redux map misses the initial snapshot
  // for non-doctor users (PDS), which made every doctor look offline until an event arrived.
  const { statuses } = useRoomDoctorStatuses(waitingRoomId)

  return useMemo(
    () =>
      doctors?.map((doctor) => ({
        id: doctor._id,
        name: doctor.userInfo.name,
        surname: doctor.userInfo.surname,
        status: waitingRoomId && doctor.activeWaitingRooms.includes(waitingRoomId) ? 'available' : 'unavailable',
        liveStatus: statuses[doctor._id],
      })) ?? [],
    [doctors, waitingRoomId, statuses]
  )
}
